export default {"src":"/_next/static/media/refresh.e8a8c062.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};